import { ChevronLeftIcon } from '@heroicons/react/20/solid'
import Button from 'app/components/Button'
import FormInput from 'app/components/form/FormInput'
import FormPanel from 'app/components/form/FormPanel'
import FormSelect from 'app/components/form/FormComboSelect'
import { SmartForm } from 'app/components/form/SmartForm'
import SubmitButton from 'app/components/form/SubmitButton'

export type BudgetEditComponentProps = {
  isEdit: boolean
  showSpend: boolean
  defaultValues: Record<string, any>
  hiddenInputs: { name: string; value: string | undefined }[]
  onDelete: () => void
  onBack: () => void
  onSubmit: (values: any) => Promise<void>
  validator: any
}

const inputClassName =
  'rounded-lg border border-default bg-surface px-4 py-3 text-ui-sm text-default shadow-elevation-1'

export function BudgetEditComponent({
  isEdit,
  showSpend,
  defaultValues,
  hiddenInputs,
  onDelete,
  onBack,
  onSubmit,
  validator,
}: BudgetEditComponentProps) {
  return (
    <>
      <div className="flex justify-between border-b border-default pb-6">
        <div className="flex items-center">
          <button
            className="flex h-10 w-10 items-center justify-center rounded-full border border-default shadow-elevation-1"
            onClick={onBack}
          >
            <ChevronLeftIcon className="h-4 w-4" />
          </button>
          <h5 className="ml-4 text-strong">{isEdit ? `Edit Budget` : `Add New Budget`}</h5>
        </div>
      </div>
      <SmartForm
        id="budgetForm"
        hideButtons={true}
        validator={validator}
        defaultValues={defaultValues}
        hiddenInputs={hiddenInputs}
        showDelete={isEdit}
        onDelete={onDelete}
        preventSubmit={true}
        onSubmit={onSubmit}
      >
        <FormPanel title="Budget Details" cols={6}>
          <div className="mx-4 flex flex-col gap-y-4">
            <FormInput
              type="month"
              name="yearMonth"
              label="Month & Year"
              labelClassName="required lbl"
              className={inputClassName}
              disabled={isEdit}
              cols={6}
            />
            <FormInput
              type="number"
              name="amount"
              label="Budget"
              labelClassName="required lbl"
              className={inputClassName}
              min={0}
              cols={6}
            />
            {showSpend && (
              <FormInput
                type="number"
                name="targetSpend"
                label="Target Spend"
                labelClassName="lbl"
                className={inputClassName}
                min={0}
                cols={6}
              />
            )}
            <FormInput
              type="number"
              name="leadGoal"
              label="Lead Goal"
              labelClassName="lbl"
              className={inputClassName}
              min={0}
              cols={6}
            />
            <FormInput
              type="number"
              name="mqlGoal"
              label="Qualified Lead Goal"
              labelClassName="lbl"
              className={inputClassName}
              min={0}
              cols={6}
            />
            <FormInput
              type="number"
              name="patientGoal"
              label="Patient Goal"
              labelClassName="lbl"
              className={inputClassName}
              min={0}
              cols={6}
            />
            <FormSelect
              required={true}
              options={[
                { label: `Digital Marketing`, value: `Digital Marketing` },
                { label: `All Channels`, value: `` },
              ]}
              name="channel"
              label="Channel"
              labelClassName="required lbl"
              className={inputClassName}
              cols={6}
            />
            <div className="sticky bottom-0 left-0 mb-6 grid bg-surface">
              <div className="flex justify-between">
                <Button mode="tertiary" label="Reset" size="xl" className="mr-4 rounded-full" type="reset" />
                <SubmitButton mode="primary" size="xl" label="Save" className="rounded-full" />
              </div>
            </div>
          </div>
        </FormPanel>
      </SmartForm>
    </>
  )
}
